<template>
	<div class="header-submenu">
		<div class="header-submenu__industries">
			<p class="header-submenu__title">See how actiTIME works for</p>
			<div class="header-submenu__items">
				<a :href="item.url" :class="`header-submenu__item--${item.slug}`" v-for="item in industries">
					<div class="header-submenu__item" @click="$emit('close-menu')">
						<img :src="item.icon" />
						<div class="header-submenu__link">{{ item.name }}</div>
					</div>
				</a>
			</div>
			<div class="header-submenu__item-icon header-submenu__item-icon--right">
				<link-arrow text="See all industries" href="/testimonials" />
			</div>
		</div>
		<ATInAction></ATInAction>
	</div>
</template>
<script>
import ATInAction from '../header/ATInAction.vue';
import LinkArrow from '../partials/LinkArrow.vue';

export default {
	data() {
		return {
			industries: [
				{
					slug: 'architecture',
					name: 'Architecture',
					url: '/testimonials/timesheet-for-architects',
					icon: '/dist/img/header/industries/architecture.svg',
				},
				{
					slug: 'consulting',
					name: 'Consulting',
					url: '/testimonials/consultant-time-tracking',
					icon: '/dist/img/header/industries/consulting.svg',
				},
				{
					slug: 'design',
					name: 'Design',
					url: '/testimonials/timesheet-for-designers',
					icon: '/dist/img/header/industries/design.svg',
				},
				{
					slug: 'it',
					name: 'IT',
					url: '/testimonials/it-time-tracking',
					icon: '/dist/img/header/industries/it.svg',
				},
				{
					slug: 'education',
					name: 'Education',
					url: '/testimonials/education-time-tracking',
					icon: '/dist/img/header/industries/education.svg',
				},
				{
					slug: 'engineering',
					name: 'Engineering',
					url: '/testimonials/engineering-timesheet',
					icon: '/dist/img/header/industries/engineering.svg',
				},
				{
					slug: 'healthcare',
					name: 'Healthcare',
					url: '/testimonials/time-tracking-for-healthcare',
					icon: '/dist/img/header/industries/healthcare.svg',
				},
				{
					slug: 'small-business',
					name: 'Small Business',
					url: '/testimonials/timesheet-software-for-small-business',
					icon: '/dist/img/header/industries/small-business.svg',
				},
				{
					slug: 'case-studies',
					name: 'Case studies',
					url: '/all-case-study',
					icon: '/dist/img/header/industries/case-studies.svg',
				},
			],
		};
	},
	components: {
		ATInAction,
		LinkArrow,
	},
};
</script>

<style lang="scss">
@import '../../../../scss/layout/header/header-submenu.scss'
</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/Clients.vue